import { keywords } from "../../keywords";

export interface ReportRecord {
    reportGuid: string;
    reportStatus: string;
}

export interface ValidationResult {
    isValid: boolean;
    errorMessage: string | null;
    validReportCount: number;
}

const MAX_SELECTION_COUNT = 20;
const SUCCESS_STATUS = keywords.completed;

export function validateSelection(
    selectedReportGuids: string[],
    records: ReportRecord[]
): ValidationResult {
    const selectedRecords = records.filter((r) => selectedReportGuids.includes(r.reportGuid));
    const successfulRecords = selectedRecords.filter((r) => r.reportStatus === SUCCESS_STATUS);

    if (selectedRecords.length === 0) {
        return { isValid: false, errorMessage: "no_selection", validReportCount: 0 };
    }
    if (selectedRecords.length > MAX_SELECTION_COUNT) {
        return {
            isValid: false,
            errorMessage: "over_limit",
            validReportCount: selectedRecords.length,
        };
    }
    if (successfulRecords.length !== selectedRecords.length) {
        return {
            isValid: false,
            errorMessage: "non_successful",
            validReportCount: successfulRecords.length,
        };
    }
    return { isValid: true, errorMessage: null, validReportCount: successfulRecords.length };
}
